import {
  getCountries,
  getCountryCallingCode,
  isValidPhoneNumber,
  parsePhoneNumberFromString
} from "libphonenumber-js/min";

const DEFAULT_COUNTRY = "AU";
const PREFERRED_COUNTRIES = ["AU", "NZ", "SG", "MY", "HK", "GB", "US"];

let countryNameFormatter;
let cachedCountryOptions;

function getCountryName(iso) {
  try {
    if (!countryNameFormatter && typeof Intl !== "undefined" && Intl.DisplayNames) {
      countryNameFormatter = new Intl.DisplayNames(["en"], { type: "region" });
    }
    if (countryNameFormatter) {
      return countryNameFormatter.of(iso) || iso;
    }
  } catch (e) {
    // Fall through to ISO code when Intl.DisplayNames is unavailable.
  }
  return iso;
}

function toCountryOption(iso) {
  const callingCode = getCountryCallingCode(iso);
  return {
    iso: iso,
    callingCode: callingCode,
    label: getCountryName(iso) + " +" + callingCode
  };
}

export function getCountryOptions() {
  if (cachedCountryOptions) {
    return cachedCountryOptions;
  }

  const all = getCountries();
  const preferred = {};
  PREFERRED_COUNTRIES.forEach(function(iso) {
    preferred[iso] = true;
  });

  const preferredOptions = PREFERRED_COUNTRIES.filter(function(iso) {
    return all.indexOf(iso) !== -1;
  }).map(toCountryOption);

  const remainingOptions = all
    .filter(function(iso) {
      return !preferred[iso];
    })
    .map(toCountryOption)
    .sort(function(a, b) {
      return a.label.localeCompare(b.label);
    });

  cachedCountryOptions = preferredOptions.concat(remainingOptions);
  return cachedCountryOptions;
}

export function getCountryIsoFromVenue(venueInfo) {
  const country =
    venueInfo && venueInfo.Location && venueInfo.Location.Country
      ? String(venueInfo.Location.Country).trim()
      : "";

  if (!country) {
    return DEFAULT_COUNTRY;
  }

  if (/^[A-Za-z]{2}$/.test(country)) {
    const iso = country.toUpperCase();
    return getCountries().indexOf(iso) !== -1 ? iso : DEFAULT_COUNTRY;
  }

  const lower = country.toLowerCase();
  const match = getCountries().find(function(iso) {
    return getCountryName(iso).toLowerCase() === lower;
  });
  return match || DEFAULT_COUNTRY;
}

export function isValidPhone(value, countryIso) {
  if (!value) {
    return false;
  }
  try {
    return isValidPhoneNumber(String(value), countryIso || DEFAULT_COUNTRY);
  } catch (e) {
    return false;
  }
}

export function formatPhoneForPos(value, countryIso) {
  const phone = parsePhoneNumberFromString(
    String(value || ""),
    countryIso || DEFAULT_COUNTRY
  );
  if (phone && phone.isValid()) {
    return phone.format("E.164");
  }
  return String(value || "").trim();
}

export function registerPhoneCountryValidator(Validator) {
  Validator.extend("phone_country", {
    getMessage: function() {
      return "Phone number is invalid";
    },
    validate: function(value, args) {
      var country = Array.isArray(args) ? args[0] : args;
      return isValidPhone(value, country);
    }
  });
}
